var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDropper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.112 5.165a3.025 3.025 0 0 0 0-4.279 3.094 3.094 0 0 0-4.276 0L16.4 3.324c-1.012 1.013-3.123.789-4.579-.013a2.6 2.6 0 0 0-3.057 4.144l1.416 1.416-8.155 8.154a3.455 3.455 0 0 0-.593 4.129L.293 22.293a1 1 0 0 0 0 1.414 1 1 0 0 0 1.414 0l1.139-1.139a3.455 3.455 0 0 0 4.129-.593l8.154-8.155 1.416 1.416a2.6 2.6 0 0 0 4.144-3.057c-.8-1.456-1.025-3.568-.013-4.58zM5.56 20.561a1.536 1.536 0 0 1-2.121 0 1.5 1.5 0 0 1 0-2.121l8.155-8.154 2.121 2.121zm13.7-14.376c-1.759 1.759-1.5 4.832-.325 6.958a.578.578 0 0 1-.119.679.621.621 0 0 1-.859 0l-7.779-7.781A.612.612 0 0 1 10.606 5a.522.522 0 0 1 .251.063c2.126 1.17 5.2 1.434 6.958-.325L20.254 2.3a1.045 1.045 0 0 1 1.446 0 1.024 1.024 0 0 1 0 1.449z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDropper);
export default __webpack_public_path__ + "static/media/eye-dropper.11c5c7316192a25c93d6db833e79678c.svg";
export { ForwardRef as ReactComponent };